const Asteroid02Icon = /*#__PURE__*/ [
  ["path", { d: "M17 14.5C17 18.6421 13.6421 22 9.5 22C5.35786 22 2 18.6421 2 14.5C2 10.3579 5.35786 7 9.5 7C13.6421 7 17 10.3579 17 14.5Z", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7 13L14.5 5.50003M18 2L16.5 3.5M22 6.00003L19 9M11 16L14 13", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }]
];

export { Asteroid02Icon as default };
//# sourceMappingURL=Asteroid02Icon.js.map
